'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var background = _ref.background,
      font = _ref.font,
      foreground = _ref.foreground,
      image = _ref.image,
      size = _ref.size,
      spacing = _ref.spacing,
      styles = _ref.styles;
  var rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      colors = _ref2.colors,
      treatments = _ref2.treatments,
      calculateSpacing = _ref2.calculateSpacing,
      justifyContent = _ref2.justifyContent;

  var defaultStyles = {
    root: {
      display: 'block',
      position: 'relative',
      perspective: '1000px',
      WebkitPerspective: '1000px',
      textAlign: 'center',
      width: '100%',
      paddingBottom: '100%',
      '&:hover > div:first-child': {
        transform: 'rotateY(180deg)'
      },
      '&:hover > div:last-child': {
        transform: 'rotateY(0)'
      }
    },

    wrapper: _extends({
      backfaceVisibility: 'hidden',
      display: 'flex',
      position: 'absolute',
      top: 0,
      left: 0,
      padding: rhythm(1),
      height: '100%',
      width: '100%',
      transition: '0.5s ease-out',
      transformStyle: 'preserve-3d',
      flexDirection: 'column',
      alignItems: 'center',
      alignContent: 'center'
    }, justifyContent('center'), {
      textAlign: 'center',
      backgroundColor: colors[background],
      color: colors[foreground],
      fontSize: scale(size)
    }, calculateSpacing(spacing), treatments[font]),

    front: {
      transform: 'rotateY(0)',
      visibility: 'visible',
      zIndex: 1,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        background: image && 'url(' + image + ')'
      }
    },

    back: {
      transform: 'rotateY(-180deg)'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/flippy/styles.js
// module id = 833
// module chunks = 0